import styled from "styled-components";
import { errorColor } from "../../../../../../config/constants";

// Styles
export const MainDiv = styled.div`
  margin: auto;
  padding: 16px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #fff;
  gap: 8px;
`;
export const NotesTitle = styled.p`
  margin-bottom: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const NotesDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;
export const NoteDate = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
`;
export const Textarea = styled.textarea`
  padding: 10px;
  width: 88%;
  min-width: 88%;
  max-width: 88%;
  max-height: 130px;
  border: ${({ error }) => `1px solid ${error ? errorColor : "#e6e6e6"}`};
  background-color: rgba(242, 242, 242, 0.95);
  outline: none;
  border-radius: 5px;
  color: #808080;
  font-size: 14px;
  font-weight: 400;
`;
export const ActionsDiv = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const CancelButton = styled.button`
  padding: 8px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1.5px solid #26a9b6;
  background: #fff;
  color: #26a9b6;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const NewNoteButton = styled.button`
  padding: 8px 16px;
  width: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  background: #26a9b6;
  box-shadow: 0px 1px 0px 0px #1c7983;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
